import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6fbfcc7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"margin-top":"10px"}
}
const _hoisted_2 = {
  key: 0,
  class: "cm-align-center",
  style: {"line-height":"1rem","height":"100%"}
}
const _hoisted_3 = { class: "cm-ellipsis-line-one" }
const _hoisted_4 = {
  key: 0,
  style: {"flex":"1"}
}
const _hoisted_5 = { class: "cm-ellipsis-line-one" }
const _hoisted_6 = ["title"]

import Copy from '@/views/_components/copy/copy.vue'
import { ElMessageBox } from 'element-plus'
import { formLabelStyle } from '@/components/cmForm/globalOpt'
import { formatTimeStamp } from '@/utils/time'
import { PropType, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue'

enum Type {
  source = 'source',
  target = 'target',
}
type DescribeList = {
  label: string
  type?: string
  showAddBtn?: boolean
  formatter?: (val: any) => string,
  hidden?: (val:string,describe:object) => boolean
  prop: string
  link?: boolean
  labelSpan?: number
  copy?: boolean
  line?: boolean
  valSpan?: number
}[]

export default /*#__PURE__*/_defineComponent({
  __name: 'Describe',
  props: {
  rowOpt: {
    type: Object,
    default: () => ({})
  },
  rowStyle: {
    type: Object,
    default: () => ({})
  },
  detailInfoObj: {
    type: Object,
    required: true,
  },
  type: {
    type: Object as PropType<'source' | 'target'>,
    default: 'source'
  },
  describeList: {
    type: Array as PropType<DescribeList>,
    default: () => []
  },
  describeLs: {
    type: Array as PropType<DescribeList>,
    default: () => []
  },
},
  emits: ['addWhiteList'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const { t, locale } = useI18n()

const describeListByType = computed<DescribeList>(() => {
  void locale.value
  const kind = props.type as Type
  return [
    { label: t('ransomwareIncident.riskDesc'), prop: 'description' },
    { label: t('ransomwareIncident.captureEngine'), prop: 'engine' },
    ...props.describeLs,
    { label: kind === Type.source ? t('ransomwareIncident.opProcessPid') : t('ransomwareIncident.opTargetPid'), prop: 'pid' },
    { label: t('ransomwareIncident.parentPid'), prop: 'ppid' },
    { label: kind === Type.source ? t('ransomwareIncident.opProcessCmd') : t('ransomwareIncident.opTargetCmd'), prop: 'command_line', copy: true },
    { label: t('ransomwareIncident.currentWorkingDirectory'), prop: 'current_working_directory' },
    { label: kind === Type.source ? t('ransomwareIncident.opProcess') : t('ransomwareIncident.opTarget'), prop: 'image_path', copy: true, showAddBtn: kind === Type.source },
    { label: kind === Type.source ? t('ransomwareIncident.opProcessMd5') : t('ransomwareIncident.opTargetMd5'), prop: 'md5_hash', copy: true, link: true },
    { label: t('ransomwareIncident.signatureValid'), prop: 'signature_valid' },
    { label: t('ransomwareIncident.signer'), prop: 'signer' },
    { label: t('ransomwareIncident.cloudScan'), prop: 'scan_result' },
    { label: t('ransomwareIncident.opTargetPath'), prop: 'file_path' },
    { label: t('ransomwareIncident.opTime'), prop: 'creation_time' },
    { label: t('ransomwareIncident.serviceName'), prop: 'auth_service' },
    { label: t('ransomwareIncident.user'), prop: 'users' },
    { label: t('ransomwareIncident.startTime'), prop: 'start_time', formatter: (val) => formatTimeStamp(val, 'YYYY-MM-DD HH:mm:ss'), hidden: (val) => Boolean(val === '0' || !val) },
    { label: t('ransomwareIncident.endTime'), prop: 'end_time', formatter: (val) => formatTimeStamp(val, 'YYYY-MM-DD HH:mm:ss'), hidden: (val) => Boolean(val === '0' || !val) },
    { label: t('ransomwareIncident.repeatTimes'), prop: 'repeat_times', hidden: (val) => Boolean(val === '0' || !val) },
    { label: t('ransomwareIncident.srcIp'), prop: 'src_ip' },
    { label: t('ransomwareIncident.srcPort'), prop: 'src_port' },
    { label: t('ransomwareIncident.destIp'), prop: 'dest_ip' },
    { label: t('ransomwareIncident.destPort'), prop: 'dest_port' },
    { label: t('ransomwareIncident.networkDirection'), prop: 'network_direction' },
    {
      label: t('ransomwareIncident.protocol'),
      prop: 'dest_port',
      formatter: (val) => ({ 445: t('ransomwareIncident.smb'), 3389: t('ransomwareIncident.rdp') } as Record<number, string>)[val as number],
    },
    { label: t('ransomwareIncident.exploitVuln'), prop: 'name' },
  ]
})

const handleAddWhiteList = (val: string) => {
  ElMessageBox.confirm(
    `<div>${t('ransomwareIncident.addToWhitelistConfirm')}</div>`,
    t('ransomwareIncident.tip'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('ransomwareIncident.confirm'),
      cancelButtonText: t('ransomwareIncident.cancel'),
    },
  )
    .then(() => {
      emits('addWhiteList', val)
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_intel_link = _resolveDirective("intel-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.describeList.length ? __props.describeList : describeListByType.value), (describe) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        ((describe.hidden && !describe.hidden?.(__props.detailInfoObj[describe.prop],describe)) ?? __props.detailInfoObj[describe.prop])
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              style: _normalizeStyle({ display: 'flex', 'margin-bottom': '30px', ...__props.rowStyle }),
              row: __props.rowOpt
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  class: "label-cm",
                  style: _normalizeStyle(_unref(formLabelStyle)),
                  span: describe.labelSpan ?? 4
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(describe.label), 1)
                  ]),
                  _: 2
                }, 1032, ["style", "span"]),
                _createVNode(_component_el_col, {
                  span: describe.valSpan ?? 18,
                  style: {"line-height":"normal"}
                }, {
                  default: _withCtx(() => [
                    (describe.copy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(Copy, null, {
                              default: _withCtx(() => [
                                (describe.link)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
                                        [_directive_intel_link, __props.detailInfoObj[describe.prop]]
                                      ]),
                                      (describe.showAddBtn)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 0,
                                            type: "text",
                                            onClick: ($event: any) => (handleAddWhiteList(__props.detailInfoObj[describe.prop]))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(t)('ransomwareIncident.addProcessWhitelist')), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      style: {"line-height":"1.3rem"},
                                      class: "cm-ellipsis-line-one",
                                      title: __props.detailInfoObj[describe.prop]
                                    }, _toDisplayString(__props.detailInfoObj[describe.prop]), 9, _hoisted_6))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          (describe.showAddBtn)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleAddWhiteList(__props.detailInfoObj[describe.prop])),
                                style: {"min-height":"auto","padding":"0","margin-left":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('ransomwareIncident.addProcessWhitelist')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      : (describe.type === 'IP')
                        ? (_openBlock(), _createBlock(IPColumn, {
                            key: 1,
                            cip: __props.detailInfoObj.client_ip,
                            sip: __props.detailInfoObj.system_ip
                          }, null, 8, ["cip", "sip"]))
                        : _renderSlot(_ctx.$slots, describe.prop, {
                            key: 2,
                            value: __props.detailInfoObj[describe.prop],
                            item: describe
                          }, () => [
                            _createElementVNode("div", {
                              class: _normalizeClass(describe.line && 'cm-ellipsis-line-one'),
                              style: {"line-height":"1.3rem","word-break":"break-all"}
                            }, _toDisplayString(describe?.formatter?.(__props.detailInfoObj[describe.prop]) ?? __props.detailInfoObj[describe.prop]), 3)
                          ])
                  ]),
                  _: 2
                }, 1032, ["span"])
              ]),
              _: 2
            }, 1032, ["style", "row"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
}
}

})